/**
 * The backend returns timestamps in UTC but without a timezone indicator
 * (e.g. "2026-08-13T14:00:00"). JavaScript's Date constructor treats a
 * zone-less string as local time, which shifts every displayed time by the
 * user's UTC offset. Appending "Z" tells JS to interpret it as UTC so
 * toLocale* methods convert it back to the correct local time.
 */
export function normalizeTimestamp(value: string): string {
  if (!value) return value;
  const trimmed = value.trim();
  // Already has an explicit timezone (Z, +HH:MM, or -HH:MM at the end).
  if (/[zZ]$/.test(trimmed) || /[+-]\d{2}:?\d{2}$/.test(trimmed)) {
    return trimmed;
  }
  return `${trimmed}Z`;
}

export function toDate(value: string): Date {
  return new Date(normalizeTimestamp(value));
}
